import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UserAppleUdidSchema } from './shapes';

/**
 * Move a UDID row to a different user (UCH-448). Requires
 * `releases:udids:manage`. Registration/verification marks are untouched —
 * the device's Apple-side registration belongs to the device, not the person.
 */
export const ReassignAppleUdidBodySchema = z.object({ userId: z.string().uuid() }).strict();
export type ReassignAppleUdidBody = z.infer<typeof ReassignAppleUdidBodySchema>;

export const reassignAppleUdid = defineEndpoint({
  method: 'PATCH',
  path: '/v1/apple-udids/:udidId/owner',
  params: z.object({ udidId: z.string().uuid() }),
  query: z.object({}),
  body: ReassignAppleUdidBodySchema,
  response: z.object({ data: UserAppleUdidSchema }),
});
